import { Controller } from "@hotwired/stimulus";
function throttle(callback, delay) {
  let shouldWait = !1;
  return (...args) => {
    shouldWait || (callback.apply(this, args), shouldWait = !0, setTimeout(() => {
      shouldWait = !1;
    }, delay));
  };
}
const _ScrollProgress = class _ScrollProgress extends Controller {
  initialize() {
    this.scroll = this.scroll.bind(this);
  }
  connect() {
    this.throttleDelayValue > 0 && (this.scroll = throttle(this.scroll, this.throttleDelayValue)), window.addEventListener("scroll", this.scroll, { passive: !0 }), this.scroll();
  }
  disconnect() {
    window.removeEventListener("scroll", this.scroll);
  }
  scroll() {
    const height = document.documentElement.scrollHeight - document.documentElement.clientHeight, width = window.scrollY / height * 100;
    this.element.style.width = `${width}%`;
  }
};
_ScrollProgress.values = {
  throttleDelay: {
    type: Number,
    default: 15
  }
};
let ScrollProgress = _ScrollProgress;
export {
  ScrollProgress as default
};
